var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButton',_vm._g({staticClass:"transparent corner-button dashboard-redirect-btn",class:_vm.variant,attrs:{"blurOnClick":"","id":"view-all-btn"}},_vm.$listeners),[_vm._v(" View all "),_c('IconArrowRight',{staticClass:"arrow-icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }